import React from 'react';
import packageJson from '../../../package.json';

const Version = () => {
    return (
        <pre style={{ margin: 0 }}>{packageJson.version}</pre>
    );
};

export default Version;
